import { Box } from "@mui/material";
import CustomButton from "components/common/CustomButton";
import type { PlatformEnumOption } from "features/integrationsBeta/enumLabel";
import DateRangeSelect, { PAST_PRESETS } from "./DateRangeSelect";
import FilterSelect from "./FilterSelect";

export interface ClientHistoryFilters {
  client_status?: string;
  started_after?: string;
  started_before?: string;
}

interface Props {
  filters: ClientHistoryFilters;
  onChange: (filters: ClientHistoryFilters) => void;
  /** Client-facing statuses (GET /runs/client-statuses/). */
  statuses: PlatformEnumOption[];
}

/** Filters of the client history: the client-facing status and the start date. */
export default function ClientHistoryFilterBar({
  filters,
  onChange,
  statuses,
}: Props) {
  const set = (patch: Partial<ClientHistoryFilters>) =>
    onChange({ ...filters, ...patch });

  return (
    <Box
      sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, alignItems: "center" }}
    >
      <FilterSelect
        label="Status"
        value={filters.client_status ?? ""}
        options={statuses}
        onChange={(v) => set({ client_status: v || undefined })}
      />
      <DateRangeSelect
        label="Started"
        presets={PAST_PRESETS}
        value={{ after: filters.started_after, before: filters.started_before }}
        onChange={(r) =>
          set({ started_after: r.after, started_before: r.before })
        }
      />
      <CustomButton fullWidth={false} onClick={() => onChange({})}>
        Clear Filters
      </CustomButton>
    </Box>
  );
}
